<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  heading: string;
  description: string;
  goBackText: string;
  goBackHref: string;
  showStepper: boolean;
  totalSteps?: number;
  currentStep?: number;
}>();

const {
  heading,
  description,
  goBackText,
  goBackHref,
  showStepper,
  currentStep,
  totalSteps,
} = toRefs(props);
</script>

<template>
  <pn-header
    :heading="heading"
    :go-back-href="goBackHref"
    :go-back-text="goBackText"
  >
    <p>{{ description }}</p>
    <p v-if="showStepper">
      <pn-progress-stepper
        label="Steps"
        :total-steps="totalSteps"
        :current-step="currentStep"
      ></pn-progress-stepper>
    </p>
  </pn-header>
</template>

<style lang="scss" scoped></style>
